module.exports = __webpack_public_path__ + "img/kubo.17968fc2.jpg";